import Store from '../store';
import A from '../constants/actions';

export default class DialogUtils {

  static hideDialog() {
    Store.dispatch(A.DIALOG_HIDE);
  }

  static notification(config) {
    const extendedConfig = {
      ...config,
      buttons: [
        {
          label: 'OK',
          action: DialogUtils.hideDialog,
          style: 'btn-danger',
        }
      ]
    };

    Store.dispatch(A.DIALOG_SHOW, extendedConfig);
  }

  static errorNotification(message) {
    DialogUtils.notification(
      {
        title: 'Error',
        message,
      }
    );
  }

  static confirmOperation(config) {

    const extendedConfig = {
      title: 'Confirm operation',
      message: config.message,
      buttons: [
        {
          label: 'Yes',
          action: () => {
            config.yesAction();
            DialogUtils.hideDialog();
          },
          style: 'btn-danger',
        },
        {
          label: 'No',
          action: DialogUtils.hideDialog,
        }
      ]
    };

    Store.dispatch(A.DIALOG_SHOW, extendedConfig);
  }

}